Backbone = require 'backbone'

module.exports = BrowsePageEvents = _.extend {}, Backbone.Events
